import {JobDetails} from '../../JobDetail/utilTypes';

export enum EntryPoint {
  PROJECT = 'PROJECT',
  // Potential future change: differentiate collections on artifacts vs registries
  PORTFOLIO = 'PORTFOLIO',
  REGISTRY = 'REGISTRY',
  // old style model registries
  TEAM_MODEL_REGISTRY = 'TEAM_MODEL_REGISTRY',
  WORKSPACE_PANEL = 'WORKSPACE_PANEL',
}

export interface JobOption {
  value: JobDetails;
  label: string;
}

export type TriggerFeatureFlags = {
  metricChangeNotificationsEnabled: boolean;
  runMetricZscoreEnabled: boolean;
};
